import React, { useMemo } from 'react';
import { PrefundReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { usePrefundInvoiceBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'payroll-report-card';
const PrefundInvoiceCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const { date, amount, isLoading } = usePrefundInvoiceBriefQuery();
  const childrenNode = useMemo(() => {
    if (!isSystem && (date || amount || isLoading)) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title="Most recent invoice"
          items={[
            {
              label: 'Date',
              value: date ? date : '',
            },
            {
              label: 'Amount',
              value: amount ? amount : '',
            },
          ]}
        />
      );
    }
    return null;
  }, [amount, date, isLoading, isSystem]);

  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.PrefundInvoiceCard);
  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      testId={TEST_ID}
      url={ROUTES.PREFUND_INVOICE_REPORT}
      icon={
        <PrefundReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Prefund Invoice"
      description="View prefunding invoice details,
including plan enrollments, policy election
amounts, and funding calculations"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default PrefundInvoiceCard;
